import { format, parseISO } from 'date-fns';

export const formatBookmarkDate = (date) => {
  if (!date) {
    return '';
  }
  return format(parseISO(date), 'yyyy-MM-dd HH:mm');
};